<template>
    <transition name="modal-fade">
        <div id="modalEditBanner" class="dibble-modal modal-account-verification" style="z-index: 9999">
            <div class="modal small-m">
                <div
                    class="modal-dialog modal-form "
                    role="document"
                    style="width: 600px"
                >
                    <div class="modal-content" style="min-width: 600px !important;">
                        <div class="modal-header">
                            <p class="title-modal">
                <span class="distribute-title">
                  Distribute Campaign
                </span>
                            </p>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="closeModal"
                            >
                                <img src="@/assets/images/close-dialog.svg" alt="close-icon">
                            </button>
                        </div>
                        <div class="modal-body form-box mt-2">
                            <div class="user-modal-content" style="overflow: visible">
                                <div class="distribute-section">
                                    <div class="section-number">
                                        1
                                    </div>
                                    <div class="section-content">
                                        <p>Click here to download an Excel template for campaign distribution.</p>
                                        <p class="text-left"><button class="btn distribute-btn" @click="downloadTemplate">Download Template</button></p>
                                    </div>
                                </div>
                                <div class="distribute-section">
                                    <div class="section-number">
                                        2
                                    </div>
                                    <div class="section-content">
                                        <div>
                                            Fill the Excel file with your distribution list.
                                            <ol>
                                                <li>Names will be used for personal addressing. If no name is provided, a general addressing will be used.</li>
                                                <li>Any email address provided will be used to send an email.</li>
                                                <li>Any phone number provided will be used to send an SMS.</li>
                                            </ol>

                                        </div>
                                    </div>
                                </div>
                                <div class="distribute-section">
                                    <div class="section-number">
                                        3
                                    </div>
                                    <div class="section-content">
                                        <p>
                                            Upload your distribution list. <br>
                                            <span class="desc-text">
                                                Only Excel files that comply with the templated we provided will be processed correctly.
                                            </span>
                                        </p>
                                        <input type="file" style="display: none" ref="inputSelectExcel" @change="selectExcelFile" accept=".xlsx" class="form-control">
                                        <p class="text-left"><button class="btn distribute-btn" @click="$refs.inputSelectExcel.click()">Select Distribution List</button></p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="d-flex justify-content-center mt-5">
                                    <button v-text="'Upload'"
                                            :disabled="!excel_file_content"
                                            class="btn-dialog btn-sm ok-btn mr-2 distribution-upload-btn" @click="uploadExcel">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import DibbleApi from "@/api";
import DibbleJs from "@/dibble";
import DibbleJS from "@/dibble";
import DibbleAPI from "@/api";

export default {
    name: "ModalCampaignDistribution",
    components: {},
    props: {
        campaign_id: String,
        data: Object
    },
    data() {
        return {
            excel_file_content: null,
        };
    },
    created() {
console.log('data', this.data)
    },
    watch:{
      data(){
          console.log('data', this.data)
      }
    },
    methods: {
        downloadTemplate() {
            DibbleJS.showLoader()
            DibbleJS.callApiRequest({
                '#request': DibbleAPI.api.distributionGetTemplateUrl,
            }, (response) => {
                DibbleJS.hideLoader()
                if (DibbleAPI.isResponseSuccess(response)) {
                    const { download_template_url } = response;

                    const a = document.createElement('a');
                    a.href = download_template_url;
                    a.download = 'distribution_template.xlsx';
                    a.click();
                }
            })
        },
        selectExcelFile() {
            const file = this.$refs.inputSelectExcel.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.excel_file_content = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        },
        uploadExcel() {
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.distributionUploadExcel,
                campaign_id: this.campaign_id,
                excel_file: this.excel_file_content.replace(/^data:(.*,)?/, ''),
                title: this.data.title,
                description: this.data.description,
                redirect_url: this.data.redirect_url,
            };
            DibbleJs.callApiRequest(data, (responseData) => {
                if (DibbleApi.isResponseSuccess(responseData)) {
                   this.$emit("set-distribution-data", responseData)
                } else {
                    this.$emit("distribution-data-errored")
                }
                DibbleJs.hideLoader();
            });
        },
        closeModal() {
            this.$emit("close");
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-content {
    min-width: 500px !important;
}

.modal-content, .modal-body {
    background: #EDF5F7 !important;
    border-radius: 60px !important;
    padding: 10px 20px;
}

.modal-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center;
    padding: 10px 0px !important;
    border-bottom: 1.5px solid #1C5169;
    margin: 0 20px !important;

    .title-modal {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 0.01em;
        color: #1C5169;
        margin-top: 0 !important;
    }

    button {
        border: none !important;
        outline: none !important;
        background: initial;
    }
}

.user-modal-content {
    max-height: 500px;
    overflow: scroll;
}

.btn-dialog.btn-sm {
    font-size: 14px;
    height: 40px;
}
.distribute-title {
    color: #2178AB;
}
.distribute-section {
    display: flex;
    flex-direction: row;
    margin-bottom: 25px;
    p {
        color: #555E67 !important;
        font-size: 18px !important;

        span.desc-text {
            font-size: 16px !important;
            color: #555E67;
        }
    }

    .section-number {
        background: #7BBDEF;
        color: #FFFFFF;
        width: 44px !important;
        height: 40px;
        margin-right: 20px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 28px;
        font-weight: 700;
    }

    .section-content {
        display: flex;
        flex-direction: column;
        text-align: left;
        color: #555E67;
        font-size: 18px;
        width: 100%;

        ol {
            margin: 0;
            padding-left: 20px;
            font-size: 16px;
        }

    }
}
.distribute-btn {
    font-family: 'Open Sans';
    border-radius: 20px;
    background: #d9d9d9;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    width: 280px;
    color: #555E67;
    line-height: 150%;
    margin-top: 10px;
    float: none;
}
.distribution-upload-btn {
    width: 160px;
    padding-top: 10px;
    padding-bottom: 10px;
    height: 60px !important;
    border-radius: 20px;
    font-size: 20px !important;
}
</style>
